const huePointerColor = ({ h }) => `hsl(${parseInt(h, 10)}, 100%, 50%)`;

export default huePointerColor;
